import { Component, effect, HostBinding, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { css } from '@emotion/css';
import { FeatureSet } from '../../models/feature.model';
import { RegionallyRestrictedPage } from '../../models/region.model';
import { AuthService } from '../../services/auth/auth.service';

import { RegionService } from '../../services/region/region.service';
import { UserPermissionsService } from '../../services/user-permissions/user-permissions.service';

@Component({
  selector: 'app-base',
  imports: [],
  template: ``,
})
export class BasePageComponent {
  @HostBinding('class') className = css({ flexGrow: 1 });

  auth = inject(AuthService);
  regions = inject(RegionService);
  router = inject(Router);
  permissions = inject(UserPermissionsService);

  permissionTo = this.permissions.permissionTo;

  // The router automatically populates these inputs.
  featureSet = input<FeatureSet>();
  regionalPageRestrictionKey = input<RegionallyRestrictedPage>();
  regionFallbackPath = input<string>();

  constructor() {
    // Handle Region Restriction:
    effect(() => {
      const regions = this.regions.availableRegions(this.auth.authProfile());

      // The chosen region is either the selected region or the first available region.
      const chosenRegion =
        this.regions.selectedRegionCode() ||
        this.regions.getValidRegionCode(regions());

      // 1. Reroute if a region is not selected or the first available region is not available.
      if (!chosenRegion) {
        this.router.navigate(['/select-region']);
      } else {
        // 2. Ensure that the auth state has the selected region.
        this.regions.selectRegion(chosenRegion);

        // 3. Reroute if the user selects a region that is not allowed for the current feature.
        const featureReroute: string =
          this.regionFallbackPath() || '/dashboard';
        const selectedRegion = this.regions.selectedRegion();
        const pageKey = this.regionalPageRestrictionKey();
        const hasRegionAccess =
          pageKey && selectedRegion?.pageRestrictions[pageKey];
        if (chosenRegion && pageKey && !hasRegionAccess) {
          this.router.navigate([featureReroute]);
        }
      }
    });
  }
}
